import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-svgrepetidos',
  templateUrl: './svgrepetidos.component.html',
  styleUrls: ['./svgrepetidos.component.css']
})
export class SvgrepetidosComponent implements OnInit {
  @Input() color: string;
  constructor() { }

  ngOnInit() {
  }

}
